import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

import { useUserAuth } from "../../context/UserAuthContext";
import { API_URL } from "../../config";

/** OAuth callback page hit after Google flow finishes.
 *  Expects URL fragment `#session_id=XXX`. POSTs it to backend, sets the cookie,
 *  then navigates to /conta.
 *  REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useUserAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const exchange = async () => {
      const hash = location.hash || window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        toast.error("Sessão Google inválida.");
        navigate("/login");
        return;
      }
      try {
        const { data } = await axios.post(
          `${API_URL}/api/users/oauth/emergent`,
          { session_id: match[1] },
          { withCredentials: true }
        );
        setUser(data);
        // Clear the fragment from the URL
        window.history.replaceState(null, "", window.location.pathname);
        if (data.linked_tickets > 0) {
          toast.success(`Sessão iniciada · ${data.linked_tickets} bilhete(s) associado(s).`);
        } else {
          toast.success("Sessão Google iniciada com sucesso");
        }
        navigate("/conta", { state: { user: data } });
      } catch (err) {
        toast.error(err.response?.data?.detail || "Falha ao iniciar sessão com Google.");
        navigate("/login");
      }
    };

    exchange();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="text-center" data-testid="auth-callback">
        <Loader2 className="w-8 h-8 animate-spin text-amber-400 mx-auto mb-3" />
        <p className="text-zinc-400 text-sm">A finalizar sessão...</p>
      </div>
    </div>
  );
}
